module.exports = __webpack_public_path__ + "img/state-of-survival.91eb792.png";